import React from 'react';
export function Footer() {
  return <footer className="bg-brand-900 px-5 pb-32 pt-10 text-center text-brand-100" data-id="element-130" data-mp="19ivlq3plplne">
      <p className="font-serif text-xl font-bold text-white" data-id="element-131" data-mp="206ri3faq3orp">Ortho Decision System™</p>
      <p className="mx-auto mt-3 max-w-md text-[15px] leading-relaxed" data-id="element-132" data-mp="2f3s9fhp05hpn">
        Stop collecting more orthodontic information. Start organizing the information you already have into better decisions.
      </p>
      <p className="mx-auto mt-6 max-w-lg text-xs leading-relaxed text-brand-200/80" data-id="element-133" data-mp="1mgxrarfnqufc">
        Educational and organizational resource. It does not replace formal training, supervision or patient-specific clinical
        judgment.
      </p>
      <p className="mt-4 text-xs text-brand-200/80" data-id="element-134" data-mp="1w7sgo4o7aa50">© 2026 · Dr. Nathan Brooks · Ortho Decision System™ · All rights reserved.</p>
    </footer>;
}